import { http } from '../client';
import type { CallOptions } from '../types';
import type { GovernanceApi } from './governance';

// Paths mirror subsystems/identity/facade/adapters/admin-api/src/admin/governance.rs.
const seg = encodeURIComponent;
const rd = (o?: CallOptions) => ({ signal: o?.signal });

export const governanceHttp: GovernanceApi = {
  listCompliancePolicies: (q, o) => http.get('api', '/compliance/policies', { ...rd(o), query: { ...q } }),
  getCompliancePolicy: (key, o) => http.get('api', `/compliance/policies/${seg(key)}`, rd(o)),
  listComplianceDeadlines: (q, o) => http.get('api', '/compliance/deadlines', { ...rd(o), query: { ...q } }),
  getLawEnforcementRequest: (id, o) => http.get('api', `/compliance/law-enforcement-requests/${seg(id)}`, rd(o)),
};
